import classNames from 'classnames/bind'

export default function CTASlide ({children, isActive, className}) {
  return <div className={classNames('fixed bottom-[15px] left-1/2 z-20 transition-all', {
    '-translate-x-1/2 pointer-events-auto opacity-100': isActive,
    'pointer-events-none translate-x-[100%] opacity-0': !isActive
  }, className)}>
    {children}   
  </div>
}